<template>
<navBack></navBack>
  <div class="page">
    <div class="topBar">
      <text>单号：{{ orderData.orderNo }}</text>
      <text v-if="orderData.status === 0">状态：待支付</text>
      <text v-if="orderData.status >= 1">状态：已完成</text>
      <text v-if="orderData.status === -1">状态：已撤销</text>
    </div>

    <t-cell @click="goSeeCustomerDetail" :title="`客户：${orderData.customer.name}`" align="middle"
      :note="orderData.customer.mobile" hover />

    <div class="productBox casherBox">
      <div class="title">项目</div>
      <div class="productList">
        <block v-for="(item) in orderData.productList" :key="item._id">
          <div class="cartProductBox">
            <div class="firstBar flexbar">
              <div class="name">
                {{ item.name }}
                <div v-if="type === 2">
                  {{ item.product?.name }} x {{ item.cardCount }}
                </div>
                <div v-if="type === 3">
                  （{{ item.discount / 10 }}折）
                </div>
                <div v-if="type === 4">
                  充值￥{{ item.investAmount / 100 }}/赠送￥{{ item.zengAmount / 100 }}
                </div>
              </div>
              <div class="oprateBar flexbar">
                <div class="smallTxt">¥ {{ item.price / 100 }}</div>
              </div>
            </div>

            <div class="secondBar flexbar">
              <div class="title">
                {{ joinNames(item.ticheng) }}
              </div>
              <div class="oprateBar flexbar">
                <div class="smallTxt"> x {{ item.shl }}</div>
              </div>
            </div>

            <div v-if="item.discountAmount" class="secondBar flexbar">
              <div class="title"></div>
              <div class="oprateBar flexbar">
                <div class="smallTxt"> 折扣优惠：-¥ {{ item.discountAmount / 100 }}</div>
              </div>
            </div>

            <div v-if="item.operatePrice" class="secondBar flexbar">
              <div class="title"></div>
              <div class="oprateBar flexbar">
                <div class="smallTxt"> 手动调价：{{ getOperatePrice(item.operatePrice) }}</div>
              </div>
            </div>

            <div v-if="item.realPay && item.payWay !== 'cika'" class="thirdBar priceSummary">
              小计：￥{{ item.realPay / 100 }}
            </div>
            <div v-if="item.payWay === 'cika'" class="thirdBar priceSummary">
              次卡抵扣
            </div>
          </div>
        </block>

        <div class="totalPrice">合计：￥{{ orderData.sumPrice / 100 }}</div>
      </div>
    </div>

    <div class="Order_box">
      <t-cell-group title="更多信息">
        <t-cell title="下单时间" :note="orderData.createAt?.time2" />
        <t-cell title="开票员" :note="orderData.operator?.name" />
        <t-cell title="价格合计" :note="`￥${orderData.totalPrice / 100}`" />
        <t-cell v-if="orderData.operateAmount" title="调整金额" :note="getOperatePrice(orderData.operateAmount)" />
        <t-cell v-if="orderData.couponAmount" title="优惠金额" :note="`-￥${orderData.couponAmount / 100}`" />
        <t-cell v-if="orderData.cikaAmountRaw" title="次卡抵扣" :note="`-￥${orderData.cikaAmountRaw / 100}`" />
        <t-cell v-if="orderData.discountAmount" title="折扣优惠" :note="`-￥${orderData.discountAmount / 100}`" />
        <t-cell title="实际支付" :note="`￥${orderData.realPay / 100}`" />
        <t-cell v-if="orderData.realPay > 0" title="支付方式" :note="joinPayType(orderData.payType)"
          @click="showPayTypeList" hover arrow />
        <t-cell title="提成金额" :note="`￥${orderData.totalTiChengAmount / 100}`" @click="showTiChengList" hover arrow />
        <t-cell title="备注信息" :note="orderData.beiz" />
      </t-cell-group>
    </div>

    <div class="Order_box" v-if="orderData.status === -1">
      <t-cell-group title="撤销信息">
        <t-cell title="撤销人" :note="orderData.deleteOperator?.name" />
        <t-cell title="撤销时间" :note="orderData.deleteAt?.time2" />
        <t-cell title="撤销原因" :note="orderData.deleteNote" />
      </t-cell-group>
    </div>


  </div>

  <!-- 提成详情对话框 -->
  <t-popup v-model:visible="showCommssionListDialog" placement="bottom" :close-on-overlay-click="true">
    <div class="commission-dialog">
      <div class="dialog-header">
        <text class="dialog-title">提成详情</text>
      </div>


      <block v-for="(item, index) in orderData.tichengSummary" :key="index">
        <t-cell-group :title="item.productName">
          <block v-for="(item2, index2) in item.ticheng" :key="index2">
            <t-cell>
              <template #title>
                <div>{{ item2.name }}</div>
              </template>
              <template #note>
                ¥{{ item2.tichengAmount / 100 }}
              </template>
            </t-cell>
          </block>
        </t-cell-group>
      </block>


    </div>
  </t-popup>
</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { ActionSheet } from 'tdesign-mobile-vue';
import navBack  from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance();
const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
const auth = proxy.$auth;
const route = useRoute()
 
 
// 将所有字段整合到一个 reactive 对象中
const orderData = reactive({
  orderNo: '',
  status: 0,
  customer: {
    name: '',
    mobile: ''
  },
  productList: [],
  type: 1,
  sumPrice: 0,
  createAt: {},
  operator: {},
  totalPrice: 0,
  operateAmount: 0,
  couponAmount: 0,
  cikaAmountRaw: 0,
  discountAmount: 0,
  realPay: 0,
  payType: [],
  totalTiChengAmount: 0,
  beiz: '',
  deleteOperator: {},
  deleteAt: {},
  deleteNote: '',
  tichengSummary: []
})

// 保持独立的响应式变量（不需要嵌套在 orderData 中的）
const showCommssionListDialog = ref(false)

// 工具函数保持不变
const joinNames = (ticheng) => {
  if (ticheng) {
    return ticheng.map(item => item.user?.name || '').join(',')
  }
  return ''
}

const joinPayType = (payType) => {
  if (payType && payType.length) {
    return payType.map(item => item.name || '').join(',')
  }
  return ''
}

const getOperatePrice = (operatePrice) => {
  const price = operatePrice / 100
  if (price > 0) {
    return `- ¥${price}`
  } else {
    return `+ ¥${Math.abs(price)}`
  }
}

// 更新模板中使用的函数，使用 orderData
const goSeeCustomerDetail = () => {
  route.push({
    path: '/customerDetail',
    query: { id: orderData.customer.id }
  })
}

// 显示提成列表
const showTiChengList = () => {
  showCommssionListDialog.value = true
}

// 跳转到修改提成页面

// 更新 fetchOrderDetail 函数
const fetchOrderDetail = async (orderId) => {
  // 在这里实现获取订单详情的逻辑
  await auth.signInAnonymously();
  const db = app.database();

  db.collection('my_order').doc(orderId).get().then(res => {

    console.log(res.data)
    if (res.data.length)
      Object.keys(orderData).forEach((key) => {
        orderData[key] = res.data[0][key];
      })

    console.log('获取订单详情:', orderData)

  })

  // 示例数据赋值：
  /*
  orderData.orderNo = '20230601001'
  orderData.status = 1
  orderData.customer.name = '张三'
  orderData.customer.mobile = '13800138000'
  // ... 其他字段赋值
  */
}

// 初始化数据
const showPayTypeList = () => {
  let {
    payType
  } = orderData;
  let items = payType.map(item => {
    return `${item.name}  (${item.amount / 100}元)`
  });


  ActionSheet.show({
    items,
    onCancel:()=> ActionSheet.close(),
    onClose:()=>  ActionSheet.close()
  });
};

onMounted(() => {
  const orderId = route.query.id || route.params.id

  if (orderId) {
    // 根据 orderId 加载订单详情
    fetchOrderDetail(orderId)
  }
})
</script>
<style scoped>
.page {
  width: 96vw;
  margin: 0 auto;
  padding-bottom: 260px;
}

.topBar {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0 4vw;

}

.user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  overflow: hidden;
  margin-right: 8px;
}

.productList {
  padding: 0% 4vw;
  display: flex;
  flex-direction: column;

}

.cartProductBox {
  flex: 1;
}

.midBox {
  background-color: white;

  width: 96vw;
  border-radius: 6px;
  margin-bottom: 10px;

}

.midBox .priceBox {
  text-align: right;
  padding: 8px 12px;
  border-top: 0.5px solid rgb(238, 238, 238);
  font-size: 14px;
}

.strongTxt {
  font-weight: 600;
}



.Order_box {

  overflow: hidden;
}



.weui-lable {
  text-align: right;
  font-size: 14px;
  border: none;
}

.footerBox {
  padding: 5px 0;
  text-align: center;
}

.smallTxt {
  font-size: 12px;

  color: gray;
}

.bottomBtnBox {
  z-index: 20;
  position: fixed;

  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgb(240, 240, 240);
  padding: 20px 0;




}


.Order_box {
  background-color: white;
  border-radius: 6px;

  margin: 10px 0;
}

.productBox .serviceBar {
  font-size: 0.8rem;
  color: gray;
  display: flex;
  justify-content: flex-end;
}

.productBox .thirdBar {

  font-size: 0.8rem;

}

.productBox .name {
  font-size: 1rem;
}

.totalPrice {
  padding: 3vw;
  text-align: right;
}

.casherBox {
  background-color: white;
  border-radius: 2vw;
  margin-bottom: 5vw;
  padding: 3vw;
}

.flexBar {
  display: flex;
  justify-content: space-between;
}

.casherBox .title {
  color: gray;
  font-size: 0.8rem;
  margin-bottom: 3vw;
}

.cartProductBox {

  padding: 3vw 2vw;


  border-bottom: dashed 0.5px rgb(211, 211, 211);
}

.cartProductBox .firstBar {
  display: flex;
  justify-content: space-between;
}

.cartProductBox .secondBar {
  display: flex;
  justify-content: space-between;
}

.cartProductBox .firstBar .name {
  width: 60vw;
}

.cartProductBox .firstBar .oprateBar {
  width: 20vw;
  text-align: right;
}

.cartProductBox .smallTxt {
  font-size: 1rem;
  color: gray;
}

.cartProductBox .priceSummary {
  font-size: 1rem;
  color: gray;
  text-align: right;
  display: block;

}

.commissionDialog {
  display: block;
}

.dialog-header {
  padding: 10px;
}
</style>